import { CoreFilters } from '@/components/filters/core-filters';
import moment from 'moment';

export class AccountFilters extends CoreFilters {
  $filters;
  $list;
  $list2;
  listItem = '.account-table-cycle-item';
  listItem2 = '.account-table-event-item';
  $forShow;
  $forShow2;
  $loadMore;
  $loadMore2;
  $hideAll;
  $hideAll2;
  $empty;
  $empty2;
  showItems = 4;
  showItems2 = 4;
  showItemsStep = 4;
  specializations = [];
  dateStart = '';
  dateEnd = '';
  hideFinished = false;
  text = '';

  constructor() {
    super();
    this.init();
  }

  init() {
    this.$filters = $('.account-events-actions');

    if (!this.$filters || this.$filters.length === 0) return;

    this.$list = $('.account-table-cycle');
    this.$list2 = $('.account-table-events');
    this.$loadMore = $('.account-filter-cycle-load-more');
    this.$loadMore2 = $('.account-filter-event-load-more');
    this.$hideAll = $('.account-filter-cycle-hide-all');
    this.$hideAll2 = $('.account-filter-event-hide-all');
    this.$empty = $('.account-filter-cycle-empty');
    this.$empty2 = $('.account-filter-event-empty');

    this.initAllListeners();
    this.initLoadMore();

    this.filterCycleData();
    this.filterEventData();
  }

  initLoadMore() {
    this.$loadMore.on('click', () => {
      this.showItems += this.showItemsStep;
      this.showFiltered(this.$forShow, this.showItems);
      this.checkLoadMore(
        this.$forShow,
        this.$loadMore,
        this.$hideAll,
        this.$empty,
        this.showItems,
        this.showItemsStep
      );
    });

    this.$hideAll.on('click', () => {
      this.showItems = this.showItemsStep;
      this.showFiltered(this.$forShow, this.showItems);
      this.checkLoadMore(
        this.$forShow,
        this.$loadMore,
        this.$hideAll,
        this.$empty,
        this.showItems,
        this.showItemsStep
      );
    });

    this.$loadMore2.on('click', () => {
      this.showItems2 += this.showItemsStep;
      this.showFiltered(this.$forShow2, this.showItems2);
      this.checkLoadMore(
        this.$forShow2,
        this.$loadMore2,
        this.$hideAll2,
        this.$empty2,
        this.showItems2,
        this.showItemsStep
      );
    });

    this.$hideAll2.on('click', () => {
      this.showItems2 = this.showItemsStep;
      this.showFiltered(this.$forShow2, this.showItems2);
      this.checkLoadMore(
        this.$forShow2,
        this.$loadMore2,
        this.$hideAll2,
        this.$empty2,
        this.showItems2,
        this.showItemsStep
      );
    });
  }

  initAllListeners() {
    const $text = $('.account-filter-text');
    const $dateStart = $('.account-filter-date-start');
    const $dateEnd = $('.account-filter-date-end');
    const $filterHidden = $('.account-filter-hidden');

    $filterHidden.on('change', () => {
      this.hideFinished = $filterHidden.prop('checked');
      this.filterCycleData();
      this.filterEventData();
    });

    $text.on('keyup', () => {
      this.text = $text.val();
    });

    $dateStart.on('change', () => {
      this.dateStart = $dateStart.val();
    });

    $dateEnd.on('change', () => {
      this.dateEnd = $dateEnd.val();
    });

    $('.account-filter-submit').on('click', () => {
      this.filterCycleData();
      this.filterEventData();
    });
  }

  filterCycleData() {
    const $items = this.$list.find(this.listItem);
    $items.addClass('filter-hide').removeClass('filter-for-show');

    $items.each((i, el) => {
      const $t = $(el);
      let toShow = false;
      const filters = {
        text: false,
        dateStart: false,
        dateEnd: false,
      };

      if (this.hideFinished) {
        toShow = !$t.data('finished');
      } else {
        toShow = true;
      }

      if (toShow) {
        if (this.text.length > 0) {
          const text = this.text.toLowerCase();
          let name = $t.data('name');
          let documentStatus = $t.data('documnetstatus');
          let status = $t.data('status');
          let statusText = $t.data('statustext');
          let button = $t.data('button');
          const filtersText = {
            name: false,
            documentStatus: false,
            status: false,
            statusText: false,
            button: false,
          };

          if (name && name.length > 0) {
            filtersText.name = name.toLowerCase().includes(text);
          } else {
            filtersText.name = false;
          }

          if (documentStatus && documentStatus.length > 0) {
            filtersText.documentStatus = documentStatus
              .toLowerCase()
              .includes(text);
          } else {
            filtersText.documentStatus = false;
          }

          if (status && status.length > 0) {
            filtersText.status = status.toLowerCase().includes(text);
          } else {
            filtersText.status = false;
          }

          if (statusText && statusText.length > 0) {
            filtersText.statusText = statusText.toLowerCase().includes(text);
          } else {
            filtersText.statusText = false;
          }

          if (button && button.length > 0) {
            filtersText.button = button.toLowerCase().includes(text);
          } else {
            filtersText.button = false;
          }

          filters.text =
            filtersText.name ||
            filtersText.documentStatus ||
            filtersText.status ||
            filtersText.statusText ||
            filtersText.button;
        } else {
          filters.text = true;
        }

        if (this.dateStart.length > 0) {
          let dateStart = this.dateStart;
          dateStart = dateStart.split('.');
          dateStart = moment(`${dateStart[2]}-${dateStart[1]}-${dateStart[0]}`);

          const dataDateStart = moment($t.data('startdate'));
          filters.dateStart =
            dataDateStart.isAfter(dateStart) || dataDateStart.isSame(dateStart);
        } else {
          filters.dateStart = true;
        }

        if (this.dateEnd.length > 0) {
          let dateEnd = this.dateEnd;
          dateEnd = dateEnd.split('.');
          dateEnd = moment(`${dateEnd[2]}-${dateEnd[1]}-${dateEnd[0]}`);

          const dataDateEnd = moment($t.data('enddate'));
          filters.dateEnd =
            dataDateEnd.isBefore(dateEnd) || dataDateEnd.isSame(dateEnd);
        } else {
          filters.dateEnd = true;
        }

        if (!filters.text || !filters.dateStart || !filters.dateEnd) {
          toShow = false;
        }

        if (toShow) $t.addClass('filter-for-show');
      }
    });

    this.$forShow = this.$list.find(this.listItem + '.filter-for-show');

    this.showFiltered(this.$forShow, this.showItems);
    this.checkLoadMore(
      this.$forShow,
      this.$loadMore,
      this.$hideAll,
      this.$empty,
      this.showItems,
      this.showItemsStep
    );
  }

  filterEventData() {
    const $items = this.$list2.find(this.listItem2);
    $items.addClass('filter-hide').removeClass('filter-for-show');

    $items.each((i, el) => {
      const $t = $(el);
      let toShow = false;
      const filters = {
        text: false,
        dateStart: false,
        dateEnd: false,
      };

      if (this.hideFinished) {
        toShow = !$t.data('finished');
      } else {
        toShow = true;
      }

      if (toShow) {
        if (this.text.length > 0) {
          const text = this.text.toLowerCase();
          let name = $t.data('name');
          let eventType = $t.data('type');
          let status = $t.data('status');
          let button = $t.data('button');
          const filtersText = {
            name: false,
            eventType: false,
            status: false,
            button: false,
          };

          if (name && name.length > 0) {
            filtersText.name = name.toLowerCase().includes(text);
          } else {
            filtersText.name = false;
          }

          if (eventType && eventType.length > 0) {
            filtersText.eventType = eventType.toLowerCase().includes(text);
          } else {
            filtersText.eventType = false;
          }

          if (status && status.length > 0) {
            filtersText.status = status.toLowerCase().includes(text);
          } else {
            filtersText.status = false;
          }

          if (button && button.length > 0) {
            filtersText.button = button.toLowerCase().includes(text);
          } else {
            filtersText.button = false;
          }

          filters.text =
            filtersText.name ||
            filtersText.eventType ||
            filtersText.status ||
            filtersText.button;
        } else {
          filters.text = true;
        }

        if (this.dateStart.length > 0) {
          let dateStart = this.dateStart;
          dateStart = dateStart.split('.');
          dateStart = moment(`${dateStart[2]}-${dateStart[1]}-${dateStart[0]}`);

          const dataDate = moment($t.data('date'));
          filters.dateStart =
            dataDate.isAfter(dateStart) || dataDate.isSame(dateStart);
        } else {
          filters.dateStart = true;
        }

        if (this.dateEnd.length > 0) {
          let dateEnd = this.dateEnd;
          dateEnd = dateEnd.split('.');
          dateEnd = moment(`${dateEnd[2]}-${dateEnd[1]}-${dateEnd[0]}`);

          const dataDate = moment($t.data('date'));
          filters.dateEnd =
            dataDate.isBefore(dateEnd) || dataDate.isSame(dateEnd);
        } else {
          filters.dateEnd = true;
        }

        if (!filters.text || !filters.dateStart || !filters.dateEnd) {
          toShow = false;
        }

        if (toShow) $t.addClass('filter-for-show');
      }
    });

    this.$forShow2 = this.$list2.find(this.listItem2 + '.filter-for-show');

    this.showFiltered(this.$forShow2, this.showItems2);
    this.checkLoadMore(
      this.$forShow2,
      this.$loadMore2,
      this.$hideAll2,
      this.$empty2,
      this.showItems2,
      this.showItemsStep
    );
  }
}
